<template>
  <div class="container-h-full qr-code">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="swiper-item" v-for="(slide, index) in swiperSlides" :key="index">
        <!-- <div class="label">
          <p>{{getCodeStatusDes(slide.status)}}</p>
        </div>-->
        <div class="content">
          <div class="qrcode" ref="qrcode"></div>

          <p>
            <span class>姓名：</span>
            {{slide.userName}}
          </p>
          <p>
            <span class>证件号：</span>
            {{slide.idcard}}
          </p>
          <p>
            <span class>使用日期：</span>
            {{formatTime(slide.activityStaTime)}} {{getTime(slide.activityStaTime)}} - {{getTime(slide.activityEndTime)}}
          </p>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import http from "@js/http-zyz.js";
import qccode from "@image/personalCenter/qccode-bg.png";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { entryDetail } from "@js/volunteerUrl";
import util from "@util";
import QRCode from "qrcode";

export default {
  name: "QRCode",
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    openId() {
      return this.$store.state.userInfo.openId;
    }
  },

  data() {
    return {
      qccode,
      swiperOption: {
        loop: false, // 循环
        speed: 500, //切换速度
        mousewheelControl: false, // 禁止鼠标滚轮切换
        lazy: {
          loadPrevNext: true
        },
        pagination: {
          el: ".swiper-pagination",
          bulletActiveClass: "my-bullet-active"
        },
        autoplay: false,
        // autoplay: {
        //   delay: 2000,
        //   stopOnLastSlide: false, // 切换到最后一个时不停止
        //   disableOnInteraction: false //用户操作swiper之后 不停止autoplay
        // },
        watchSlidesProgress: true,
        centeredSlides: true, //设定为true时，活动块会居中，而不是默认状态下的居左。
        spaceBetween: -16,
        slidesPerView: 1.2,
        loopedSlides: 2,
        observer: true,
        observeParents: true
      },
      swiperSlides: []
    };
  },
  created() {
    let { activityId, volunteerId } = this.$route.query;
    this.getDetail(activityId, volunteerId);
  },
  mounted() {},

  methods: {
    getDetail(activityId, volunteerId) {
      http
        .post(entryDetail, {
          activityId,
          volunteerId,
          openId: this.openId
        })
        .then(res => {
          let data = res.data.data;
          this.swiperSlides = [data];
          this.$nextTick(() => {
            this.createdQRCode(data.entryId);
          });
        });
    },
    createdQRCode(id,index=0) {
      let container = this.$refs["qrcode"][index];
      QRCode.toCanvas(
        id,
        {
          errorCorrectionLevel: "H",
          width: this.$refs["qrcode"][index].clientHeight, // 设置宽度
          height: this.$refs["qrcode"][index].clientWidth // 设置高度
        },
        (error, canvas) => {
          container.appendChild(canvas);
        }
      );
    },
    formatTime(time) {
      time = time.replace(/-/g,'/')
      return util.formatTime(new Date(time), "yyyy-MM-dd");
    },
    getTime(item) {
      item = item.replace(/-/g,'/')
      return util.getTime(item);
    }
  }
};
</script>

<style lang="less" scoped>
.qr-code {
  display: flex;
  align-items: center;
  background: linear-gradient(
    270deg,
    rgba(101, 133, 227, 1) 0%,
    rgba(42, 167, 170, 1) 100%
  );
  .swiper {
    &-item {
      height: 100%;
      background-image: url("../../lib/image/personalCenter/qccode-bg.png");
      background-size: 100% 98%;
    }
    .label {
      width: 160px;
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      background: linear-gradient(
        240deg,
        rgba(255, 181, 0, 0.8) 40%,
        rgba(255, 84, 0, 0.8) 100%
      );
      transform: rotate(-45deg) translate(-48px, -90%);
      position: absolute;
      top: 0;
      left: 0;
      p {
        text-shadow: 0px 5px 12px rgba(31, 68, 80, 0.5);
      }
    }

    .content {
      width: 100%;
      font-size: 14px;
      color: #9e9e9e;
      text-align: left;

      .qrcode {
        width: 136px;
        height: 136px;
        margin: 0 auto;
        box-shadow: 0px 4px 6px 4px #dfdfdf;
        margin-bottom: 30px;
        display: block;
      }
      p {
        margin-bottom: 16px;

        span {
          color: #32373c;
          font-weight: 600;
        }
      }
    }
  }
}
.swiper-container {
  width: 100%;
  height: ~"calc(100% - 160px)";
  padding: 80px 0;
}
.swiper-slide {
  border-radius: 22px;
  text-align: center;
  font-size: 18px;
  padding: 60px 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 5px 5px 0px rgba(31, 68, 80, 0.1);
  /* Center slide text vertically */
  position: relative;
  display: flex;
  flex-direction: column;
  transition: 300ms;
  transform: scale(0.8);
  overflow: hidden;
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
.swiper-pagination {
  bottom: 5%;
}
</style>

<style lang="less">
.my-bullet {
  bottom: 20px;
}
.my-bullet-active {
  background: #ffffff;
}
.swiper-wrapper {
  height: 100%;
}
</style>